





























































































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({})
export default class BridgeHistoryPagination extends Vue {
  @Prop({type: Boolean, required: true}) hasNextPage!: boolean
  @Prop({type: Boolean, required: true}) hasPreviousPage!: boolean
  @Prop({type: Boolean, required: true}) isOnFirstPage!: boolean
  @Prop({type: Number, required: true}) currentPage!: number

  handleNextPage() {
    this.$emit('next-page')
  }

  handleFirstPage() {
    this.$emit('first-page')
  }

  handlePreviousPage() {
    this.$emit('previous-page')
  }
}
